import AppUsersRepository from './AppUsersRepository';
import allocations from './allocations';
import circlesRepository from './circlesRepository';
import employees from './employees';
import forecasts from './forecasts';
import groups from './groups';
import milestones from './milestones';
import overallocations from './overallocations';
import GroupCommentRepository from './GroupCommentRepository';
import notificationsRepository from './notificationsRepository';
import reportRepository from './reportRepository';
import holidayRepository from './holidayRepository';
import groupTemplateRepository from './groupTemplateRepository';
import salaryManualInputRepository from './salaryManualInputRepository';
import agreementRepository from './agreementRepository';
import gpsDataRepository from './gpsDataRepository';
import salaryRatesRepository from './salaryRatesRepository';

const repositories = {
  "appUsers": AppUsersRepository,
  "groupComments": GroupCommentRepository,
  allocations,
  "circles": circlesRepository,
  employees,
  forecasts,
  groups,
  milestones,
  overallocations,
  'notifications': notificationsRepository,
  'reports': reportRepository,
  holidayRepository,
  groupTemplateRepository,
  agreementRepository,
  gpsData: gpsDataRepository,
  salaryRatesRepository: salaryRatesRepository,
  salaryManualInput: salaryManualInputRepository
};

export default {
  get: name => repositories[ name ]
};
